/*jslint node: true, browser: true, todo: true*/

"use strict";

var initializeBreadcrumbs = require("pli/breadcrumbs");
var ko = require("pli/knockout");
var pli = require("pli/forms");
var ServerCalculation = require("pli/util/serverComputed").default;

var entityRegistry = require("../entity-registry");
var NotificationMessage = require("../common-notificationmessage");
var selectionForm = require("../common-selectionform");
var viewModelInit = require("./viewModelInitExtensions");

require("pli/forms-viewmodel").enableSlideTransitions();
require("../geoschema");


//-------------------------------------------
viewModelInit.createRoot = function createDocumentViewModelRoot() {

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ViewModel extensions
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    // This section defines methods that apply to
    // any type of document. They will be available
    // in viewmodel creator function for current
    // document and can be overridden by assigning
    // a function to a viewmodel property of
    // the same name.

    var viewModel = null, // extension methods use closure to this value
        entityName = pli.forms.root.id,
        entityViewModelCreatorMethod = "create".concat(entityName.substring(0, 1).toUpperCase(), entityName.substring(1), "ViewModel"),
        entityViewModelCreator = viewModelInit[entityViewModelCreatorMethod], // e.g. "createSurfaceLeaseViewModel"
        entityFactoriesCreatorMethod = entityViewModelCreatorMethod.replace("ViewModel", "Factories"),
        entityFactoriesCreator = viewModelInit[entityFactoriesCreatorMethod]; // e.g. "createSurfaceLeaseFactories"

    if (typeof entityViewModelCreator !== "function") {
        throw new Error("Required method pli.viewModelInit." + entityViewModelCreatorMethod + " is not defined");
    }
    if (!entityViewModelCreator.viewModelPrototype) {
        throw new Error("Required property pli.viewModelInit." + entityViewModelCreatorMethod + ".viewModelPrototype is not defined");
    }
    if (!entityFactoriesCreator) {
        throw new Error("Required property pli.viewModelInit." + entityFactoriesCreatorMethod + " is not defined");
    }


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.close = function documentClose() {
        /// <summary>
        /// Close this document's window.
        /// </summary>
        var rootForm = pli.forms.root,
            forms = pli.forms,
            f = forms.getCurrentForm();
        while (f !== rootForm) {
            f.close();
            f = forms.getCurrentForm();
        }
        rootForm.close();
        return false;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.help = function documentHelp() {
        /// <summary>
        /// Show help for this document.
        /// </summary>
        entityRegistry.help.show(viewModel.extras.helpUrl);
        return false;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.home = function documentHome() {
        /// <summary>
        /// Goes to the root of the form.
        /// </summary>
        location.hash = pli.forms.crumbs().begin.hash;
        return false;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.nextTab = function documentNextTab() {
        /// <summary></summary>
        /// <summary></summary>
        return entityViewModelCreator.viewModelPrototype._switchTab(1);
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.previousTab = function documentPreviousTab() {
        /// <summary></summary>
        return entityViewModelCreator.viewModelPrototype._switchTab(-1);
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.print = function documentPrint() {
        /// <summary>
        /// Print this document.
        /// </summary>
        entityRegistry[entityName].open.print({
            id: viewModel.guid(),
            uniqueName: viewModel.id()
        });
        return false;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.duplicate = function documentDuplicate() {
        /// <summary>
        /// Duplicate this document.  This means that we need to clear the GUID of this
        /// document and all of the owned child documents.
        /// </summary>
        viewModel.extras.state("busy.duplicate");
        selectionForm.utils.resetGuids(viewModel);

        // if the viewModel has splits, we need to check for a lands/rights grid.
        if (viewModel.splits) {
            // The lands/rights grids maintain their own list of guids for the tracts, so
            // we have to reset them separately.
            viewModel.splits().forEach(function (split) {
                if (split.extras.landsRightsEditGrid) {
                    split.extras.landsRightsEditGrid.resetTractIds();
                }
            }, this);
        }

        viewModel.extras.rootData.id = '';
        location.hash = '';
        viewModel.id("DUPLICATE OF " + viewModel.id());

        // select the name field, but do it in just a moment to give the UI a chance to update first
        setTimeout(function afterDuplicate() {
            viewModel.extras.state("ready.dirty");
            pli.forms.crumbs.peek().begin.page.findActivationFocus().focus().select();
        }, 400);

        return false;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.up = function moveUpDocumentHierarchy() {
        /// <summary></summary>
        var c = pli.forms.crumbs().end;
        if (c.previous && c.previous.hash) {
            location.hash = c.previous.hash;
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeDirtyState = function computeDirtyState() {
        var s = this.extras.state();
        if (s === "ready" || s === "ready.saved") {
            if (this.extras.dirty()) {
                this.extras.state("ready.dirty");
            }
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeWarningState = function computeWarningState() {
        var s = this.extras.state();
        if (s) {
            s = s.replace(".failed", "");
            if (s.indexOf("ready") === 0) {
                if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
                    this.extras.state(s + ".failed");
                } else {
                    this.extras.state(s);
                    this.extras.isErrorListVisible(false); // explicit hiding error list menu
                }
            }
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeSaveStateMessage = function computeSaveStateMessage() {
        switch (this.extras.state()) {
        case "busy.saving":
            return { message: "Saving", stateIndicationClass: "fileSaving" };
        case "ready.saved":
            return { message: "Saved", stateIndicationClass: "fileSaved" };
        case "ready.dirty":
        case "ready.failed":
        case "ready.saved.failed":
        case "ready.dirty.failed":
        case "ready":
            return { message: "Save", stateIndicationClass: "noChanges" };
        default:
            return { message: "Save", stateIndicationClass: "noChanges" };
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeDuplicateStateMessage = function computeDuplicateStateMessage() {
        if (this.extras.state() === "busy.duplicate") {
            return { message: "Duplicating", stateIndicationClass: "fileDuplicating" };
        }
        return { message: "Duplicate", stateIndicationClass: "noChanges" };
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeReadOnly = function computeDocumentReadOnly() {
        return !this.extras.isEditable() || this.extras.state().indexOf("ready") !== 0;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeReady = function computeDocumentReady() {
        return this.extras.state().indexOf("ready") === 0;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeStatus = function computeDocumentStatus() {
        if (ko.isObservable(this.extras.statusText)) {
            return this.extras.statusText() || "";
        }

        if (ko.isObservable(this.status)) {
            var status = this.status && this.status.item(),
                withCategory = status && status.length > 3;

            return (status
                ? "".concat(status[1] || status[0], withCategory ? " (".concat(status[2], ")") : "")
                : "(No status yet)");
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeSubtitle = function computeDocumentSubtitle() {
        if (ko.isObservable(this.extras.subtitleField)) {
            return (this.extras.subtitleField() || "(No ".concat(this.extras.subtitleFieldName.toLowerCase(), " yet)"));
        }

        if (ko.isObservable(this.area)) {
            var area = this.area.item();
            return (area
                ? "".concat(area[0], ", ", area[1], ", ", area[2])
                : "(No area yet)");
        }

        if (ko.isObservable(this.workTitle)) {
            var workTitle = this.workTitle();
            return (workTitle || "(No work title yet)");
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeTitle = function computeDocumentTitle() {
        /// <summary>
        /// Compute and set browser window title
        /// + return it (to bind it to form header
        /// title as well).
        /// </summary>
        var title,
            entityDisplayName = entityRegistry[entityName].type;

        if (this.extras.state().substring(0, 4) === "init") {
            title = "Loading ".concat(entityDisplayName, "...");
        } else if (ko.isObservable(this.extras.titleOverride)) {
            title = this.extras.titleOverride();
        } else {
            title = ko.utils.stringTrim(this.id());
            title = (title.length === 0
                ? "(No ".concat(entityDisplayName.toLowerCase(), " number yet)")
                : entityDisplayName.concat(" ", title));
        }
        document.title = title;
        return title;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeSaveButtonToolTip = function computeSaveButtonToolTip() {
        /// <summary>
        /// Compute and set tool tip for Save button
        /// </summary>
        var entityDisplayName = entityRegistry[entityName].type;

        if (this.extras.state().indexOf('.failed') === -1) {
            return "Save all changes to this ".concat(entityDisplayName.toLowerCase()).concat(" (Ctrl+S)");
        }
        return "";
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._loadDocument = function documentLoad(record) {
        /// <remarks>
        /// TODO: This should become part of ViewModelInit.js's
        /// loadViewModel function (save original loadViewModel method
        /// as _loadViewModelOriginal, then define loadViewModel that points
        /// to a function that calls _loadViewModelOriginal and
        /// at the end runs applyResult on server calculation,
        /// if server calculation is active in that viewmodel).
        /// </remarks>
        ko.postbox.publish("state.isEditable", (record ? record.editable : true));
        this.loadViewModel(record);
        if (this.extras._serverCalculation) {
            this.extras._serverCalculation.applyResult(record);
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._switchTab = function switchDocumentTab(offset) {
        /// <summary>
        /// Switches the currently active tab
        /// backward or forward based on the offset
        /// specified.
        /// </summary>
        var c = pli.forms.crumbs().end, i, l;
        if (c && c.page && c.page.parent && c.page.parent.children && c.page.parent.children.length > 1) { // do we have a sibling?
            l = c.page.parent.children.length;
            for (i = 0; i < l; i += 1) {
                if (c.page === c.page.parent.children[i]) { break; }
            }
            i += offset;
            if (i < 0) {
                i = l - 1;
            } else if (i > (l - 1)) {
                i = 0;
            }
            window.location.hash = c.page.parent.children[i].activationHash;
            return false;
        }
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.showErrorList = function showErrorList() {
        /// <summary>
        /// Show tooltip list
        /// </summary>
        if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
            this.extras.isErrorListVisible(true);
        }
        return false;
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._hideErrorList = function hideErrorList() {
        /// <summary>
        /// Hide tooltip list
        /// </summary>
        this.extras.isErrorListVisible(false);
        return true; // allow event propagation & default handling
    };


    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.moveOutErrorList = function moveOutErrorList() {
        /// <summary>
        /// Move cursor out the errorlist or the save button tooltip list
        /// </summary>
        if (this.extras.disableMouseOutHiding()) {
            return false;
        }
        this.extras.isErrorListVisible(false);
        return true;
    };


    //---------------------------------------
    /*jslint unparam: true*/
    entityViewModelCreator.viewModelPrototype._safeSaving = function safeSaving(data, e) {
        if (e && e.stopImmediatePropagation) {
            e.stopImmediatePropagation(); // prevent hiding the tool tip while it showing by click on Save button
        }

        this.extras.disableMouseOutHiding(true);
        // Check if viewModel has errors before saving then showing tooltip list
        if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
            this.extras.isErrorListVisible(true);
        } else {
            this.extras.disableMouseOutHiding(false);
            this.save();
        }
        return false; // stop propagation & default (if keyboard event)
    };
    /*jslint unparam: false*/

    //--------------------------------------
    entityViewModelCreator.viewModelPrototype._showErrorPanelAfterSaving = function showErrorPanelAfterSaving() {
        /// <summary>
        /// Show notification error panel in case if viewModel state is "failed" and errors count is 0 (unknown server-side error)
        /// or show error list tooltip if errors count isn't 0 (known server-side error)
        /// </summary>
        var s = this.extras.state(), p = this.extras.prevState();
        if ((s === "ready.failed" || s === "ready.saved.failed" || s === "ready.dirty.failed") && p === "busy.saving") {
            if (this.extras.errorsCount() === 0) {
                this.extras.notificationErrorPanel.show({
                    title: "Save failed",
                    message: "Unexpected save error"
                });
            } else {
                this.extras.disableMouseOutHiding(true);
                this.extras.isErrorListVisible(true);
            }
            this.extras.prevState(s); // reset previous state observable
        }
    };


    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ViewModel initialization
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    // extra steps to run after all modules finish creating viewmodel
    viewModelInit.onViewModelCreated(function onDocumentViewModelCreated(viewModel, viewModelInit) {
        viewModel.extras.dirty = ko.dirtyFlag(viewModel, true, true); // create suspended
        viewModel.extras.breadcrumbs = initializeBreadcrumbs(pli.forms.crumbs);
        viewModel.extras.crumbData = ko.computed(function () {
            var crumbs = pli.forms.crumbs();
            return (crumbs && crumbs.end && crumbs.end.data && crumbs.end.data.value) ? crumbs.end.data.value : {};
        });
        viewModel.extras.isEditable = ko.observable().subscribeTo("state.isEditable");
        viewModel.extras.isReadOnly = ko.computed(viewModel._computeReadOnly, viewModel);
        viewModel.extras.isReadOnly.publishOn("state.isReadOnly");
        viewModel.extras.isReady = ko.computed(viewModel._computeReady, viewModel);
        viewModel.extras.isReady.publishOn("state.isReady");
        viewModel.extras.status = ko.computed(viewModel._computeStatus, viewModel);
        viewModel.extras.subtitle = ko.computed(viewModel._computeSubtitle, viewModel);
        viewModel.extras.title = ko.computed(viewModel._computeTitle, viewModel);
        viewModel.extras.saveButtonTooltip = ko.computed(viewModel._computeSaveButtonToolTip, viewModel);

        viewModel.extras.prevState = ko.observable(viewModel.extras.state());
        viewModel.extras.state.subscribe(function (oldValue) {
            viewModel.extras.prevState(oldValue);
        }, viewModel, "beforeChange");

        viewModel.extras.isErrorListVisible = ko.observable(false).extend({ rateLimit: 0 });
        viewModel.extras.disableMouseOutHiding = ko.observable(false);
        viewModel.extras.isErrorListVisible.subscribe(function (newValue) {
            if (!newValue) {
                viewModel.extras.disableMouseOutHiding(false);
            }
        });

        viewModel.extras.notificationMessage = new NotificationMessage();
        viewModel.extras.notificationErrorPanel = new NotificationMessage();
        viewModel.hideErrorList = viewModel._hideErrorList.bind(viewModel);
        viewModel.safeSaving = viewModel._safeSaving.bind(viewModel);

        viewModel.extras.suppressBusyIndicator = true;
        viewModel.extras.saveStateMessage = ko.computed(viewModel._computeSaveStateMessage, viewModel);
        viewModel.extras.duplicateStateMessage = ko.computed(viewModel._computeDuplicateStateMessage, viewModel);
        ko.computed(viewModel._computeDirtyState, viewModel);
        ko.computed(viewModel._computeWarningState, viewModel);
        ko.computed(viewModel._showErrorPanelAfterSaving, viewModel);

        viewModel.extras._serverCalculation = viewModel.extras.calculationCallName ? new ServerCalculation(viewModel.extras.calculationCallName, viewModel, 200) : null;

        viewModel.save = viewModelInit.secureAction(viewModel.save, viewModel);
        viewModelInit.defaultKeymap = ko.utils.extend(
            ko.utils.extend({}, pli.config.defaultKeymap),
            {
                "Back": viewModel.up,
                "Close": viewModel.close,
                "Help": viewModel.help,
                "Home": viewModel.home,
                "NextTab": viewModel.nextTab,
                "PreviousTab": viewModel.previousTab,
                "Print": viewModel.print,
                "Save": viewModel.safeSaving,
                "Duplicate": viewModel.duplicate
            }
        );
    });

    // create root document viewModel
    var factories = entityFactoriesCreator(entityName);
    factories.computeErrorsCount = viewModelInit.computeErrorsCount;
    viewModel = entityViewModelCreator(factories);
    viewModelInit.finalizeFactories(factories, viewModel);
    viewModelInit.assignKeymaps();

    // create adapter (TODO: update ViewModelInit.js and delete)
    if (viewModel.loaded) { throw new Error("Root viewModel defined method \"loaded\" -- this is now deprecated, please define \"loadViewModel\" instead"); }
    entityViewModelCreator.viewModelPrototype.loaded = entityViewModelCreator.viewModelPrototype._loadDocument;
    if (viewModel.created) { throw new Error("Root viewModel defined method \"created\" -- this is now deprecated, please define \"completeViewModel\" instead"); }
    entityViewModelCreator.viewModelPrototype.created = viewModel.completeViewModel;

    // define methods for dialog registry
    pli.dialogClosingMessage = function computeDocumentClosingMessage(isRootLevel) {
        var entityDisplayName = entityRegistry[entityName].type;
        return (viewModel.extras.dirty()
            ? isRootLevel
                ? "This ".concat(entityDisplayName, " has unsaved changes")
                : entityDisplayName.concat(" ", viewModel.id(), " has unsaved changes")
            : null);
    };
    pli.dialogId = function computeDocumentId() {
        return entityName.concat("-", viewModel.id());
    };

    return viewModel;
};

module.exports = viewModelInit;



//////////////////
// WEBPACK FOOTER
// ./app/document/documentForm.js
// module id = 526
// module chunks = 49